import React from 'react'
import './styles/Design.css'

import Icon from '../../common/Icon'
import { Box } from '../../common/Box'
import { px2Rem } from '../../../themes/Mixins'

const Design = ({ isAnimate, scale }) => {
  const designItems = [
    {
      icon: 'designRuler',
      class: 'ruler'
    },
    {
      icon: 'designPencil',
      class: 'pencil'
    }
  ]
  return (
    <Box
      customStyle={{
        width: `calc(${px2Rem(54)}*${scale})`,
        height: `calc(${px2Rem(54)}*${scale})`,
        marginBottom: scale === 1 ? `${px2Rem(10)}` : '',
        position: 'relative'
      }}
    >
      {
        designItems.map((item, index) =>
          <Icon
            key={index}
            icon={item.icon}
            className={isAnimate ? item.class : ''}
            customStyle={{
              position: 'absolute',
              margin: '0',
              opacity: '0',
              ...item.style
            }}
          />
        )
      }
    </Box>
  )
}

export default Design



// WEBPACK FOOTER //
// ./src/components/sections/process/Design.js